import { combineReducers } from 'redux';
import compose from './compose';
import * as fromCompose from './compose';
import execute from './execute';
import * as fromExecute from './execute';

export default combineReducers({
  compose,
  execute,
});

export const getFirstEvent = (state) => fromCompose.getFirstEvent(state.compose);

export const getReturnEvent = (state) => fromCompose.getReturnEvent(state.compose);

export const getDimensionType = (state) => fromCompose.getDimensionType(state.compose);

export const getRetentionSQL = (state) => fromCompose.getRetentionSQL(state.compose);

export const getError = (state) => fromCompose.getError(state.compose);

export const getExecutionResult = (state) => fromExecute.getResult(state.execute);

export const getExecutedQuery = (state) => fromExecute.getQuery(state.execute);

export const getOptions = (state) => fromExecute.getOptions(state.execute);

export const getExecuteTime = (state) => fromExecute.getExecuteTime(state.execute);

export const isExecuting = (state) => fromExecute.isExecuting(state.execute);

export const getExecuteId = (state) => fromExecute.getExecuteId(state.execute);
